module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-14.ac7ff832.png";